import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: "",
  audioFileLink: "",
  createdAt: "",
  description: "",
  dislikes: 0,
  duration: "",
  durationInSeconds: "",
  isFavorite: false,
  isLiked: null,
  isLive: false,
  likes: 0,
  podcastId: "",
  podcastTitle: "",
  publishedAt: null,
  textFileLink: "",
  title: "",
  cover: { big: "", small: "" },
};

export const releasePodcastInfoSlice = createSlice({
  name: "releasePodcastInfo",
  initialState,
  reducers: {
    setReleasePodcastInfo: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setReleasePodcastInfo } = releasePodcastInfoSlice.actions;

export default releasePodcastInfoSlice.reducer;
